<template>
  <div class="header clearfix">
    <div class="clearfix" :class="{auto: isIndex, auto_1720: !isIndex}">
      <div class="top-logo" v-if="info.data !== undefined">
        <router-link :to="{ name: 'Home', query: { columnId: 38 } }" v-if="!isIndex"><img :src="isIndex ? info.data[0].img2 : info.data[0].img" alt=""></router-link>
        <img v-else-if="isIndex" :src="isIndex ? info.data[0].img2 : info.data[0].img" alt="">
      </div>
      <div class="top-right">
        <div class="open-menu" :class="{show: isShow}" @click="openMenu"><i></i></div>
        <div class="search-box">
          <div class="open-search" @click="openSearch" v-if="lan === 0">搜索</div>
          <div class="open-search" @click="openSearch" v-else-if="lan === 1">Search</div>
          <div class="input-box clearfix" :class="{hide: !isShowSearch}">
            <input type="text" class="search-text" id="search-text" maxlength="50" @keyup.enter="goSearch">
            <button class="search-btn" @click="goSearch"></button>
          </div>
        </div>
        <div v-if="info.data !== undefined && info.data[0].tag === 0" class="lan">
          <span @click="changeLan">
            <img class="earth" src="@/assets/earth.png" alt="">
            <span class="en" v-if="lan === 0">EN</span>
            <span class="en" v-else-if="lan === 1">CN</span>
          </span>
        </div>
      </div>
      <div class="top-nav" :class="{show: isShow}" @mouseleave="isShow = false">
        <ul class="ul clearfix" v-if="lan === 0">
          <li v-for="item in headerList" :key="item.id" :class="{aon: item.id == columnid}">
            <router-link :to="{name: item.requestTo, query: { columnId: item.id }}">{{item.name}}</router-link>
          </li>
        </ul>
        <ul class="ul clearfix english" v-else-if="lan === 1">
          <li v-for="item in headerList" :key="item.id" :class="{aon: item.id == columnid}">
            <router-link :to="{name: item.requestTo, query: { columnId: item.id }}">{{item.enName}}</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { showToast } from '../utils/js/toast.js'
export default {
  props: {
    Index: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isIndex: this.Index,
      isShow: false,
      isShowSearch: false,
      headerList: [],
      info: this.$store.state.publicInfo,
      lan: this.$store.state.isEn,
      isLoaded: this.$store.state.isLoaded,
      columnid: ''
    }
  },
  watch: {
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
    },
    '$store.state.isLoaded' () {
      this.isLoaded = this.$store.state.isLoaded
    }
  },
  created () {
    // 将语言状态本地化
    try {
      this.lan = JSON.parse(localStorage.getItem('lan')) || 0
    } catch (e) {
      console.log(e)
    }
    this.$store.commit('changeLan1', this.lan)
    if (!this.isLoaded || localStorage.getItem('routeList') === null || localStorage.getItem('publicInfo') === null) {
      this.init()
      this.$store.commit('isLoad')
    } else {
      // try {
      // const headerList = JSON.parse(localStorage.getItem('routeList'))
      const headerList = this.$store.state.routeList
      headerList.forEach((item) => {
        if (item.parentId === 0 && item.id !== 33) {
          this.headerList.push(item)
        }
      })
        // this.info = JSON.parse(localStorage.getItem('publicInfo'))
      // } catch (err) {
      //   console.log(err)
      // }
    }
  },
  mounted () {
    let columnid = this.$route.query.columnId
    if (columnid == undefined) {
      columnid = 38
    }
    this.columnid = columnid
  },
  methods: {
    init () {
      this.headerList = []
      this.$api.post('api/benefitArticleType/queryByParam', { isDelete: 0 }, r => {
        r.data.forEach((item) => {
          // id为33为辅助栏目
          if (item.parentId === 0 && item.id !== 33) {
            this.headerList.push(item)
          }
        })

        const routeList = []
        r.data.forEach((item) => {
          let id
          if (item.parentId === 0) {
            routeList.push(item)
            id = item.id
            const children = []
            r.data.forEach((item1) => {
              if (item1.parentId === id) {
                children.push(item1)
              }
            })
            routeList[routeList.length - 1].children = children
          }
        })
        this.$store.commit('setRouteList', routeList)
        // localStorage.setItem('routeList', JSON.stringify(routeList))
        // console.log('0')
      })
      this.infor = []
      this.$api.post('/api/benefitInfo/queryByParam', { current: 1, pageSize: 2 }, r => {
        this.info = r
        this.$store.commit('setPublicInfo', r)
        // localStorage.setItem('publicInfo', JSON.stringify(r))
      })
    },
    openMenu () {
      this.isShow = !this.isShow
    },
    openSearch () {
      this.isShowSearch = !this.isShowSearch
    },
    goSearch () {
      const text = document.getElementById('search-text').value
      if (text === '') {
        showToast('请输入搜索关键词', 2000)
      } else {
        this.$router.push({
          name: 'Search',
          query: {
            search: text
          }
        })
      }
    },
    changeLan () {
      // 切换语言
      this.$store.commit('changeLan')
      this.lan = this.$store.state.isEn
      localStorage.setItem('lan', this.lan)
      // 在详情页切换语言时返回上一级页面
      let id
      try {
        id = JSON.parse(localStorage.getItem('columnId'))
      } catch (e) {
        console.log(e)
      }
      if (this.$route.matched[1] && this.$route.matched[1].meta.title === 'detail') {
        this.$router.push({
          path: this.$route.matched[0].path,
          query: {
            columnId: id
          }
        })
      }
    }
  }
}
</script>
<style scoped>
.header{width: 100%; position: absolute; top: 0; left: 0; min-width: 320px; z-index: 100;}
.header .top-logo{float: left; line-height: 100px; max-width: 190px;}
.header .top-logo img{width: 100%;}
.header .top-right{float: right; line-height: 100px;}
.header .top-right > div{float: right; margin-left: 50px;}
.header .top-nav{float: right; transition: all .3s; z-index: 100;}
.header .top-nav.show{right: 0;}

.header ul{position: relative; padding-right: 50px;}
.header ul::before{content: ''; position: absolute; right: 0; top: 50%; transform: translateY(-50%); width: 1px; height: 16px; background-color: rgba(255, 255, 255, .3);}
.header ul li{float: left; line-height: 100px; padding: 0 20px; transition: all .3s;}
.header ul li:first-child{padding-left: 0;}
.header ul li:last-child{padding-right: 0;}
.header ul li a{width: 100%; height: 100%; display: block; font-size: 18px; font-weight: lighter; color: #fff; position: relative; transition: all .3s;}
.header .english li{padding: 0 13px;}
.header ul li a::before{content: ''; background-color: #fff; position: absolute; bottom: 20px; left: 50%; width: 0; height: 2px; transform: translateX(-50%); transition: all .3s;}
.header ul li:hover a::before,
.header ul li.aon a::before{width: 100%;}

.header .search-box{position: relative; margin-left: 30px!important;}
.header .open-search{background: url(../assets/search.png)no-repeat 85% center #e4007f; width: 90px; line-height: 30px; height: 30px; color: #fff; font-size: 16px; padding-right: 20px; box-sizing: border-box; border-radius: 30px; color: #fff; font-size: 16px; text-align: center; margin: 35px 0; cursor: pointer;}
.header .input-box{position: absolute; top: 100%; right: 0; width: 300px; z-index: 10;}
.header .input-box input{width: 80%; line-height: 45px; height: 45px; background: rgba(255, 255, 255, .5); border: 1px solid rgba(255, 255, 255, .5); padding: 0 3% 0 5%; overflow: hidden; vertical-align: top; box-sizing: border-box; border-top-left-radius: 20px; outline: 0;}
.header .input-box input:focus-visible{outline: none;}
.header .input-box .search-btn{width: 20%; height: 45px; line-height: 45px; vertical-align: top; float: right; border: 1px solid rgba(255, 255, 255, .5); background: url(../assets/search.png)no-repeat center rgba(255, 255, 255, .5); cursor: pointer; border-bottom-right-radius: 20px;}

.header .open-menu{display: none; width: 35px; height: 30px; position: relative; margin: 25px 0 25px 50px; cursor: pointer;}
.header .open-menu::before,
.header .open-menu::after,
.header .open-menu i{position: absolute; width: 75%; height: 3px; background-color: #fff; left: 50%;}
.header .open-menu::before{top: 15%; content: ''; transform: translateX(-50%);}
.header .open-menu::after{bottom: 15%; content: ''; transform: translateX(-50%); top: auto;}
.header .open-menu i{top: 50%; transform: translate(-60%, -50%); width: 60%;}
.header .open-menu.show i{transform: translate(-40%, -50%);}

.header .lan{position: relative; overflow: hidden; cursor: pointer;}
.header .earth{position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); transition: all .3s; display: block;}
.header .en{transform: translateY(20px); opacity: 0; transition: all .3s; display: block; color: #fff;}
.header .lan:hover .earth{top: 30%; opacity: 0;}
.header .lan:hover .en{transform: translateY(0); opacity: 1;}
@media(max-width: 1200px){
  .header .top-right > div{margin-left: 30px;}
  .header ul{padding-right: 30px;}
  .header ul li{padding: 0 10px;}
  .header .english li{padding: 0 7px;}
  .header ul li a{font-size: 16px;}
}
@media(max-width: 1024px){
  .header .top-logo,
  .header .top-right{line-height: 80px;}
  .header .open-search{margin: 25px 0;}
  .header .top-nav{position: fixed; right: -200px; top: 80px; height: auto; padding-bottom: 10px; margin-right: 0; width: 200px; background-color: rgba(228, 0, 127, 0.795);}
  .header ul{padding-right: 0; padding-top: 10px;}
  .header ul::before{content: none;}
  .header ul li{float: none; width: 100%; line-height: 50px;}
  .header ul li:first-child{padding-left: 7px;}
  .header .open-menu{display: block;}
  .header .lan{margin-left: 0!important;}
  .header ul li:hover,
  .header ul li.aon{background-color: rgba(255, 255, 255, 0.5);}
  .header ul li:hover a,
  .header ul li.aon a{color: #fff;}
  .header ul li a::before{content: none}
}
@media(max-width: 640px){
  .header .input-box input{caret-color: #e4007f;}
}
@media(max-width: 480px){
  .header .top-logo{width: 120px;}
  .header .top-right > div{margin-left: 10px;}
  .header .search-box{margin-left: 10px!important;}
}
</style>
